export type IPixQRCodeModalProps = {
  open: boolean;
  setOpenModal: Function;
  setOpenQRCodeByEmail?: () => void; 
};

export enum PixModalState {
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
  EXPIRED = 'expired',
}